import fadeIn from '../util/fade-in';
import fadeOut from '../util/fade-out';
import {newsletterCheckForResultSection} from '../globals/newsletter';
import {register} from '../vendor/theme-scripts/theme-sections';

const selectors = {
  tracking: '[data-tracking-consent]',
  trackingAccept: '[data-confirm-cookies]',
  close: '[data-close-modal]',
  popupInner: '[data-popup-inner]',
  newsletterPopup: '[data-newsletter]',
  newsletterPopupHolder: '[data-newsletter-holder]',
  newsletterField: '[data-newsletter-field]',
  newsletterForm: '[data-newsletter-form]',
  promoPopup: '[data-promo-text]',
  delayAttribite: 'data-popup-delay',
  cookieNameAttribute: 'data-cookie-name',
  dataTargetReferrer: 'data-target-referrer',
};

const classes = {
  hide: 'hide',
  hasValue: 'has-value',
  success: 'has-success',
  desktop: 'desktop',
  mobile: 'mobile',
};

let sections = {};

class PopupCookie {
  constructor(name, value) {
    this.configuration = {
      expires: null, // session cookie
      path: '/',
      domain: window.location.hostname,
    };
    this.name = name;
    this.value = value;
  }

  write() {
    const hasCookie = document.cookie.indexOf('; ') !== -1 && !document.cookie.split('; ').find((row) => row.startsWith(this.name));
    if (hasCookie || document.cookie.indexOf('; ') === -1) {
      document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
    }
  }

  read() {
    if (document.cookie.indexOf('; ') !== -1 && document.cookie.split('; ').find((row) => row.startsWith(this.name))) {
      const returnCookie = document.cookie
        .split('; ')
        .find((row) => row.startsWith(this.name))
        .split('=')[1];

      return returnCookie;
    } else return false;
  }

  destroy() {
    if (document.cookie.split('; ').find((row) => row.startsWith(this.name))) {
      document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
    }
  }
}

class DelayShow {
  constructor(holder, element) {
    this.element = element;
    this.delay = holder.getAttribute(selectors.delayAttribite);

    if (this.delay === 'always') {
      this.always();
    }

    if (this.delay === 'delayed') {
      this.delayed();
    }

    if (this.delay === 'bottom') {
      this.bottom();
    }

    if (this.delay === 'idle') {
      this.idle();
    }
  }

  always() {
    fadeIn(this.element);
  }

  delayed() {
    // Show popup after 10s
    setTimeout(() => {
      fadeIn(this.element);
    }, 10000);
  }

  // Scroll to the bottom of the page
  bottom() {
    window.addEventListener('scroll', () => {
      if (window.scrollY + window.innerHeight >= document.body.clientHeight) {
        fadeIn(this.element);
      }
    });
  }

  // Idle for 1 min
  idle() {
    let timer = 0;
    let idleTime = 60000;
    const documentEvents = ['mousemove', 'mousedown', 'click', 'touchmove', 'touchstart', 'touchend', 'keydown', 'keypress'];
    const windowEvents = ['load', 'resize', 'scroll'];

    const startTimer = () => {
      timer = setTimeout(() => {
        timer = 0;
        fadeIn(this.element);
      }, idleTime);

      documentEvents.forEach((eventType) => {
        document.addEventListener(eventType, resetTimer);
      });

      windowEvents.forEach((eventType) => {
        window.addEventListener(eventType, resetTimer);
      });
    };

    const resetTimer = () => {
      if (timer) {
        clearTimeout(timer);
      }

      documentEvents.forEach((eventType) => {
        document.removeEventListener(eventType, resetTimer);
      });

      windowEvents.forEach((eventType) => {
        window.removeEventListener(eventType, resetTimer);
      });

      startTimer();
    };

    startTimer();
  }
}

class TargetReferrer {
  constructor(el) {
    this.el = el;
    this.locationPath = location.href;

    if (!this.el.hasAttribute(selectors.dataTargetReferrer)) {
      return;
    }

    this.init();
  }

  init() {
    if (this.locationPath.indexOf(this.el.getAttribute(selectors.dataTargetReferrer)) === -1 && !window.Shopify.designMode) {
      this.el.parentNode.removeChild(this.el);
    }
  }
}

class Tracking {
  constructor(el) {
    this.popup = el;
    this.modal = document.querySelector(selectors.tracking);
    this.modalInner = this.popup.querySelector(selectors.popupInner);
    this.close = this.modal.querySelector(selectors.close);
    this.acceptButton = this.modal.querySelector(selectors.trackingAccept);
    this.enable = this.modal.getAttribute('data-enable') === 'true';
    this.showPopup = false;

    window.Shopify.loadFeatures(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1',
        },
      ],
      (error) => {
        if (error) {
          throw error;
        }

        const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
        const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();

        this.showPopup = !userCanBeTracked && userTrackingConsent === 'no_interaction' && this.enable;

        if (window.Shopify.designMode) {
          this.showPopup = true;
        }

        this.init();
      }
    );
  }

  init() {
    if (this.showPopup) {
      fadeIn(this.modalInner);
    }

    this.clickEvents();
  }

  clickEvents() {
    this.close.addEventListener('click', (event) => {
      event.preventDefault();

      window.Shopify.customerPrivacy.setTrackingConsent(false, () => fadeOut(this.modalInner));
    });

    this.acceptButton.addEventListener('click', (event) => {
      event.preventDefault();

      window.Shopify.customerPrivacy.setTrackingConsent(true, () => fadeOut(this.modalInner));
    });

    document.addEventListener('trackingConsentAccepted', function () {
      console.log('trackingConsentAccepted event fired');
    });
  }

  onBlockSelect(evt) {
    if (this.popup.contains(evt.target) && this.showPopup) {
      fadeIn(this.modalInner);
    }
  }

  onBlockDeselect(evt) {
    if (this.popup.contains(evt.target)) {
      fadeOut(this.modalInner);
    }
  }
}

class PromoText {
  constructor(el) {
    this.popup = el;
    this.popupInner = this.popup.querySelector(selectors.popupInner);
    this.close = this.popup.querySelector(selectors.close);
    this.cookie = new PopupCookie(this.popup.getAttribute(selectors.cookieNameAttribute), 'user_has_closed');
    this.isTargeted = new TargetReferrer(this.popup);
    this.hasDeviceClass = '';

    this.init();
  }

  init() {
    const cookieExists = this.cookie.read() !== false;

    if (!cookieExists || window.Shopify.designMode) {
      if (!window.Shopify.designMode) {
        new DelayShow(this.popup, this.popupInner);
      } else {
        fadeIn(this.popupInner);
      }

      this.clickEvents();
    }
  }

  clickEvents() {
    this.close.addEventListener('click', (event) => {
      event.preventDefault();

      fadeOut(this.popupInner);
      this.cookie.write();
    });
  }

  onBlockSelect(evt) {
    if (this.popup.classList.contains(classes.mobile)) {
      this.hasDeviceClass = classes.mobile;
    }

    if (this.popup.classList.contains(classes.desktop)) {
      this.hasDeviceClass = classes.desktop;
    }

    if (this.hasDeviceClass !== '') {
      this.popup.classList.remove(this.hasDeviceClass);
    }

    if (this.popup.contains(evt.target)) {
      fadeIn(this.popupInner);
    }
  }

  onBlockDeselect(evt) {
    if (this.popup.contains(evt.target)) {
      fadeOut(this.popupInner);
    }

    if (this.hasDeviceClass !== '') {
      this.popup.classList.add(this.hasDeviceClass);
    }
  }
}

class NewsletterPopup {
  constructor(el) {
    this.popup = el;
    this.popupInner = this.popup.querySelector(selectors.popupInner);
    this.holder = this.popup.querySelector(selectors.newsletterPopupHolder);
    this.close = this.popup.querySelector(selectors.close);
    this.newsletterField = this.popup.querySelector(selectors.newsletterField);
    this.cookie = new PopupCookie(this.popup.getAttribute(selectors.cookieNameAttribute), 'newsletter_is_closed');
    this.form = this.popup.querySelector(selectors.newsletterForm);
    this.isTargeted = new TargetReferrer(this.popup);

    this.init();
  }

  init() {
    const cookieExists = this.cookie.read() !== false;

    if (!cookieExists || window.Shopify.designMode) {
      this.show();

      if (this.form.classList.contains(classes.success)) {
        this.checkForSuccess();
      }
    }
  }

  show() {
    if (!window.Shopify.designMode) {
      new DelayShow(this.popup, this.popupInner);
    } else {
      fadeIn(this.popupInner);
    }

    this.inputField();
    this.closePopup();
  }

  checkForSuccess() {
    fadeIn(this.popupInner);
    this.cookie.write();
  }

  closePopup() {
    this.close.addEventListener('click', (event) => {
      event.preventDefault();

      fadeOut(this.popupInner);
      this.cookie.write();
    });
  }

  inputField() {
    this.newsletterField.addEventListener('input', () => {
      if (this.newsletterField.value !== '') {
        this.holder.classList.add(classes.hasValue, this.newsletterField.value !== '');
      }
    });

    this.newsletterField.addEventListener('focus', () => {
      if (this.newsletterField.value !== '') {
        this.holder.classList.add(classes.hasValue, this.newsletterField.value !== '');
      }
    });

    this.newsletterField.addEventListener('focusout', () => {
      setTimeout(() => {
        this.holder.classList.remove(classes.hasValue);
      }, 2000);
    });
  }

  onBlockSelect(evt) {
    if (this.popup.contains(evt.target)) {
      fadeIn(this.popupInner);
    }
  }

  onBlockDeselect(evt) {
    if (this.popup.contains(evt.target)) {
      fadeOut(this.popupInner);
    }
  }
}

const popupSection = {
  onLoad() {
    sections[this.id] = [];

    const tracking = this.container.querySelectorAll(selectors.tracking);
    tracking.forEach((el) => {
      sections[this.id].push(new Tracking(el));
    });

    const newsletterPopup = this.container.querySelectorAll(selectors.newsletterPopup);
    newsletterPopup.forEach((el) => {
      sections[this.id].push(new NewsletterPopup(el));
    });

    const promoPopup = this.container.querySelectorAll(selectors.promoPopup);
    promoPopup.forEach((el) => {
      sections[this.id].push(new PromoText(el));
    });
  },
  onBlockSelect(evt) {
    sections[this.id].forEach((el) => {
      if (typeof el.onBlockSelect === 'function') {
        el.onBlockSelect(evt);
      }
    });
  },
  onBlockDeselect(evt) {
    sections[this.id].forEach((el) => {
      if (typeof el.onBlockDeselect === 'function') {
        el.onBlockDeselect(evt);
      }
    });
  },
};

register('popups', [popupSection, newsletterCheckForResultSection]);
